<div class="modal-header">
    <h4 class="modal-title">
        Crop Image
    </h4>
    <button
        type="button"
        class="btn-close"
        (click)="activeModal.dismiss()"
    >
    </button>
</div>
<div class="modal-body">
    <div class="vstack gap-3">
        <div class="crop-frame">
            <div class="crop-stage">
                @if (imageUrl) {
                    <img
                        #image
                        class="crop-image"
                        [src]="imageUrl"
                        alt=""
                        (load)="onImageLoaded($event)"
                    />
                }
                @if (crop) {
                    <div
                        class="crop-box"
                        role="group"
                        aria-label="Selected image crop"
                        tabindex="0"
                        [style.left.px]="cropLeft"
                        [style.top.px]="cropTop"
                        [style.width.px]="cropWidth"
                        [style.height.px]="cropHeight"
                        (pointerdown)="startDrag($event, 'move')"
                    >
                        <button
                            class="crop-handle crop-handle-nw"
                            type="button"
                            aria-label="Resize from top left"
                            (pointerdown)="startDrag($event, 'nw')"
                        >
                        </button>
                        @if (aspectRatioRange) {
                            <button
                                class="crop-handle crop-handle-n"
                                type="button"
                                aria-label="Resize from top"
                                (pointerdown)="startDrag($event, 'n')"
                            >
                            </button>
                        }
                        <button
                            class="crop-handle crop-handle-ne"
                            type="button"
                            aria-label="Resize from top right"
                            (pointerdown)="startDrag($event, 'ne')"
                        >
                        </button>
                        @if (aspectRatioRange) {
                            <button
                                class="crop-handle crop-handle-e"
                                type="button"
                                aria-label="Resize from right"
                                (pointerdown)="startDrag($event, 'e')"
                            >
                            </button>
                        }
                        <button
                            class="crop-handle crop-handle-sw"
                            type="button"
                            aria-label="Resize from bottom left"
                            (pointerdown)="startDrag($event, 'sw')"
                        >
                        </button>
                        @if (aspectRatioRange) {
                            <button
                                class="crop-handle crop-handle-s"
                                type="button"
                                aria-label="Resize from bottom"
                                (pointerdown)="startDrag($event, 's')"
                            >
                            </button>
                            <button
                                class="crop-handle crop-handle-w"
                                type="button"
                                aria-label="Resize from left"
                                (pointerdown)="startDrag($event, 'w')"
                            >
                            </button>
                        }
                        <button
                            class="crop-handle crop-handle-se"
                            type="button"
                            aria-label="Resize from bottom right"
                            (pointerdown)="startDrag($event, 'se')"
                        >
                        </button>
                    </div>
                }
            </div>
        </div>
        <div class="d-flex flex-wrap justify-content-between gap-2 gap-md-3 text-body-secondary small">
            @if (aspectRatioRange) {
                <span>
                    Aspect ratio: {{ aspectRatioLabel }} ({{ minAspectRatioLabel }}–{{ maxAspectRatioLabel }})
                </span>
            }
            <span>
                Minimum at {{ aspectRatioLabel }}: {{ minimumCropSizeLabel }}
            </span>
            <span>
                {{ cropSizeLabel }}
            </span>
        </div>
        @if (crop && !cropMeetsMinimum) {
            <div
                class="alert alert-warning mb-0 py-2"
                role="alert"
            >
                This image is too small at this aspect ratio. Drag a resize handle towards square to continue.
            </div>
        }
    </div>
</div>
<div class="modal-footer">
    <button
        class="btn btn-outline-secondary"
        type="button"
        (click)="activeModal.dismiss()"
    >
        Cancel
    </button>
    <button
        class="btn btn-primary"
        type="button"
        [disabled]="!cropMeetsMinimum"
        (click)="save()"
        data-testid="save-voucher-image-button"
    >
        Save Image
    </button>
</div>
